import { PointBase } from "abweb/dto/generated/gds/PointBase";
export class Point extends PointBase {
  static createPoint(x, y) {
    const retVal = new Point();
    retVal.initPoint(x, y);
    return retVal;
  }
  constructor() {
    super();
  }
}
//# sourceMappingURL=Point.js.map
